export enum AuthenticationEnum {
  AUTHORIZATION
}